import { Icon, type IconName } from './Icon.js';

// Gambar produk: foto pertama dari Produk & Harga bila ada; selain itu ilustrasi netral (kemasan/dus) dengan palet
// warna per id produk. Juga ubin ikon. Tidak menebak jenis produk dari namanya.

const PALETTES = ['pedas', 'balado', 'ori', 'keju', 'spiral', 'daun'];
export const flavor = (_name: unknown = '', id: unknown = 0): string =>
  PALETTES[Math.abs(Number(id) || 0) % PALETTES.length] as string;

export function Art({
  name,
  id,
  cls = '',
  photo,
}: {
  name: unknown;
  id: unknown;
  cls?: string;
  /** File foto produk ("produk/xxx.jpg") — tampil menggantikan ilustrasi. */
  photo?: string | null;
}) {
  if (photo)
    return (
      <span className={`art art-photo ${cls}`}>
        <img src={`/api/files/${photo}`} alt={String(name ?? '')} loading="lazy" />
      </span>
    );
  return (
    <span className={`art fa-${flavor(name, id)} ${cls}`} aria-hidden="true">
      <svg viewBox="0 0 100 100">
        <ellipse className="sh" cx="50" cy="86" rx="32" ry="6" />
        <path className="pk" d="M22 34l28-12 28 12v40l-28 12-28-12z" />
        <path className="pk2" d="M22 34l28 12 28-12-28-12z" />
        <path className="pk3" d="M50 46v40l28-12V34z" />
        <path className="lb" d="M30 54l14 6v12l-14-6z" />
        <path className="bw2" d="M36 28l28 12" />
      </svg>
    </span>
  );
}

export function Tile({ n, id, cls = '' }: { n: IconName; id: unknown; cls?: string }) {
  return (
    <span className={`tile t${Math.abs(Number(id) || 0) % 6} ${cls}`}>
      <Icon n={n} />
    </span>
  );
}
